import { DataQuery } from 'app/util/types/criteria';
import { Document } from 'ng2-app/modules/borrower/models/document/document.model';
import { Injectable } from '@angular/core';
import { ModelService } from 'ng2-app/modules/shared/services/model.service';
import { Observable } from 'rxjs';
import { ApiHttpClient } from 'app/http/clients/api';
import { map } from 'rxjs/operators';

@Injectable()
export class DocumentService extends ModelService<Document> {
    protected urlPath = '/document';

    constructor(http: ApiHttpClient) {
        super(http);
    }

    documentsForBorrower(borrowerId: number): Observable<Document[]> {
        const query: DataQuery = {
            criteria: {
                'documents.borrowerId': {'==': borrowerId}
            },
            sort: {'documents.created': 'DESC'}
        };
        const queryString = encodeURIComponent(JSON.stringify(query));
        return this.http.get<any[]>(`${this.endpointUrl}?query=${queryString}`).pipe(
            map(documentsArray => documentsArray.map(this.createFromResponseData))
        );
    }

    sendToOcrolus(borrowerId: number, docIds: number[], append = false): Observable<Document[]> {
        const params = {};
        params['append'] = append;
        params['documentIds'] = docIds;

        return this.http.put<Document[]>('/borrower/' + borrowerId + '/ocrolus', params);
    }

    documentUrl(id: number): string {
        return `${this.endpointUrl}/${id}?stream=1`;
    }

    protected createFromResponseData(responseData: any): Document {
        return new Document(responseData);
    }
}
